<template>
  <v-container>
    <v-card class="mstDetail" outline>
      <v-row style="height: 70px">
        <v-col cols="1">
          <div class="mstbuken">物件グループ名</div>
        </v-col>
        <v-col cols="3">
          <ryou-select
            v-model="selectGroup"
            :value="selectGroup"
            :items="objectGroupItems"
            :itemText="'build_group_name'"
            :itemValue="'build_group_id'"
            :disabled="disUserGroup"
          >
          </ryou-select>
        </v-col>
        <v-col class="mstheaderTitle mstheaderData">
          <div>
            {{ this.buildingName }}
          </div>
        </v-col>
      </v-row>
      <v-row style="height: 70px">
        <v-col cols="3">
          <ryou-combobox
            v-model="selectVehicleClass"
            :value="selectVehicleClass"
            :label="'車両区分名'"
            :items="vehicleClassItems"
            :itemText="'code_text'"
            :itemValue="'code_value'"
            :multiple="false"
            :chips="false"
            :disabled="disUserClass"
          >
          </ryou-combobox>
        </v-col>
        <v-col cols="2" style="padding-left: 8%">
          <ryou-blue-btn
            :label="'新規追加'"
            :handlerClick="handleVehicleCostAdd"
            :disabled="btnCtrl"
            :dark="darkCtrl"
          >
          </ryou-blue-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card class="mstgridlist" flat v-show="VehicleCostCard">
            <v-form ref="vehicleForm" v-model="vehicleForm" lazy-validation>
              <v-row style="height: 80px">
                <v-col cols="2">{{ this.vehicleClassName }} </v-col>
                <v-col cols="4">
                  <ryou-input
                    v-model="model.vehicle_unit_price"
                    :value="model.vehicle_unit_price"
                    :label="'利用単価'"
                    :rules="priceRules"
                    :maxlength="5"
                  >
                  </ryou-input>
                </v-col>
                <v-col cols="4">
                  <ryou-input
                    v-model="management_number"
                    :value="management_number"
                    :label="'管理台数'"
                    :rules="countRules"
                    :maxlength="5"
                  >
                  </ryou-input>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="2"> </v-col>
                <v-col cols="3">
                  <!-- 2024.12.12 kouta.noborisaka 三井化学（市原工場）:用途不明のため、「閉じる」ボタンをコメントアウト -->
                  <!-- <ryou-black-btn :label="'閉じる'" :handlerClick="VehicleCostCancel" :iconCls="'mdi-close'">
                  </ryou-black-btn> -->
                </v-col>
                <v-col cols="3">
                  <ryou-black-btn
                    :label="'登録'"
                    :handlerClick="VehicleCostOk"
                  ></ryou-black-btn>
                </v-col>
                <v-col cols="3">
                  <!-- 2024.12.12 kouta.noborisaka 三井化学（市原工場）:間違ってデータを削除する可能性があるため、「削除」ボタンをコメントアウト -->
                  <!-- <ryou-black-btn
                    :label="'削除'"
                    :handlerClick="VehicleCostDelete"
                    :iconCls="'mdi-delete'"
                    :disabled="delBtnCtrl"
                    :dark="delDarkCtrl"
                  >
                  </ryou-black-btn> -->
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card class="mstgridlist9" flat v-show="VehicleClassCard">
            <v-row style="height: 30px">
              <v-col>
                <div>
                  {{ this.vehicleClassName }}
                </div>
              </v-col>
            </v-row>
            <v-row style="padding-top: 15px">
              <v-col cols="6">
                <div class="titPadding">登録済駐車番号</div>
                <v-form ref="tableForm" v-model="tableForm" lazy-validation>
                  <ryou-table
                    ref="ryouTable"
                    :rowKey="rowKey"
                    :headers="headers"
                    :showSelect="showSelect"
                    :singleSelect="singleSelect"
                    :handleDelete="handleDelete"
                    :queryParams="queryParam"
                    :url="url"
                    :businessKeys="businessKeys"
                    :dummy="false"
                    :height="height"
                  >
                  </ryou-table>
                </v-form>
              </v-col>
              <v-col cols="6">
                <div class="titPadding">登録中駐車番号</div>
                <v-form
                  ref="editTableForm"
                  v-model="editTableForm"
                  lazy-validation
                >
                  <ryou-table
                    ref="ryouEditTable"
                    :rowKey="rowKeyEdit"
                    :headers="headersEdit"
                    :editItems="editItems"
                    :url="url"
                    :handleDelete="handleDelete"
                    :businessKeys="businessKeys"
                    :inputRules="inputRules"
                    :dummy="true"
                    :height="height"
                  >
                  </ryou-table>
                  <v-row>
                    <v-col class="mstAddbtn">
                      <ryou-blue-btn
                        :label="'追加'"
                        :handlerClick="doGridAddRow"
                        :iconCls="'mdi-plus'"
                      >
                      </ryou-blue-btn>
                    </v-col>
                    <v-col class="mstYesbtn">
                      <ryou-black-btn
                        :label="'登録'"
                        :handlerClick="doGridValidateSubmit"
                      ></ryou-black-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-container>
</template>
<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouCombobox from "@/components/formInput/RyouCombobox.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
export default {
  name: "MasterParking",
  mixins: [RyouTableMixins],
  components: {
    RyouTable,
    RyouInput,
    RyouSelect,
    RyouCombobox,
    RyouBlackBtn,
    RyouBlueBtn,
    RyouConfirm,
  },
  mounted() {
    this.inputRules.push(this.GlobalRules.required);
    this.inputRules.push(this.GlobalRules.counter_64);
    this.priceRules.push(this.GlobalRules.required);
    this.priceRules.push(this.GlobalRules.currency);
    this.countRules.push(this.GlobalRules.currency);
  },
  data() {
    return {
      btnCtrl: true,
      darkCtrl: false,
      delBtnCtrl: false,
      delDarkCtrl: true,
      VehicleClassCard: false,
      VehicleCostCard: false,
      disUserClass: false,
      disUserGroup: false,
      tableForm: true,
      editTableForm: true,
      vehicleForm: true,
      rowKey: "rowIndex",
      rowKeyEdit: "rowIndex",
      businessKeys: ["build_group_id", "vehicle_class", "vehicle_id"],
      valid: true,
      showSelect: true,
      singleSelect: false,
      selected: [],
      buildingName: "",
      vehicleClassName: "",
      management_number: "",
      build_group_id: "",
      selectGroup: "",
      selectVehicleClass: { code_value: "", code_text: "" },
      inputRules: [],
      countRules: [],
      priceRules: [],
      objectGroupItems: [],
      vehicleClassItems: [],
      dataSource: [],
      height: 336,
      headers: [
        //登録済駐車番号
        {
          text: "",
          value: "build_group_id",
          class: "blue lighten-2 little",
          align: "right",
          width: "0.01%",
          type: "hidden",
          sortable: false,
          groupable: false,
        },
        {
          text: "",
          value: "vehicle_class",
          width: "0.01%",
          type: "hidden",
          sortable: false,
          groupable: false,
        },
        {
          text: "駐車番号",
          value: "vehicle_id",
          width: "60%",
          sortable: true,
          groupable: false,
        },
        {
          text: "操作",
          value: "actions",
          align: "center",
          class: "blue lighten-2 title",
          width: "15%",
          sortable: false,
          groupable: false,
        },
      ],
      headersEdit: [
        //登録中駐車番号
        {
          text: "",
          value: "build_group_id",
          class: "blue lighten-2 little",
          align: "right",
          width: "0.1%",
          type: "hidden",
          sortable: false,
          groupable: false,
        },
        {
          text: "駐車番号",
          value: "vehicle_id",
          width: "82%",
          sortable: true,
          groupable: false,
          type: "text",
        },
        {
          text: "",
          value: "vehicle_class",
          width: "0.01%",
          type: "hidden",
          sortable: false,
          groupable: false,
        },
        {
          text: "操作",
          value: "actions",
          align: "center",
          class: "blue lighten-2 title",
          width: "15%",
          sortable: false,
          groupable: false,
        },
      ],
      url: {
        originlist: "/masterParking/vehicleClassListGet/",
        delete: "/masterParking/vehicleClassDelete",
        list: "/masterParking/vehicleClassListGet/" + null + "/" + null,
      },
      model: {
        vehicle_unit_price: "",
      },
      editItems: [
        {
          vehicle_id: "",
          vehicle_class: "",
          build_group_id: "",
        },
      ],
    };
  },
  created() {
    this.buildGroupList();
    this.vehicleClassNameList();
  },
  watch: {
    selectGroup(value) {
      var that = this;
      if (
        this.selectVehicleClass.code_value != null &&
        this.selectVehicleClass.code_value != "" &&
        value != null &&
        value != ""
      ) {
        that.btnCtrl = false;
        that.darkCtrl = true;
        that.delBtnCtrl = false;
        that.delDarkCtrl = true;
        that.build_group_id = value;
        that.selectValues = this.selectVehicleClass.code_value;
        that.selectValue = this.selectVehicleClass.code_text;
        that.tableLoading(that.selectValues);
        that.VehicleCostInfoGet(that.selectValues);
        that.$refs.ryouEditTable.loadData();
        that.openEditTableForm();
        that.vehicleClassName = that.selectValue;
        that.editems(that.selectValues);
      } else if (
        this.selectVehicleClass != null &&
        this.selectVehicleClass != "" &&
        value != null &&
        value != "" &&
        this.selectVehicleClass.code_value != ""
      ) {
        that.selectVehicleClass = { code_value: "", code_text: value };
        that.btnCtrl = false;
        that.darkCtrl = true;
        that.delBtnCtrl = true;
        that.delDarkCtrl = false;
        that.build_group_id = value;
        that.selectValue = this.selectVehicleClass.code_text;
        that.openEditTableForm();
        that.vehicleClassName = that.selectValue;
      } else {
        that.VehicleCostCard = false;
        that.VehicleClassCard = false;
        that.userDateUpdateFlg = false;
        that.selectValues = null;
        that.tableLoading(that.selectValues);
      }

      if (value != null) {
        this.vehicleClassNameList();
        let params = {
          build_group_id: value,
        };
        this.getRequest(
          "/masterParking/buildingNameGet",
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          this.buildingName = data.result;
        });
      } else {
        this.buildingName = "";
      }
    },
    selectVehicleClass(value) {
      var that = this;
      if (
        this.selectVehicleClass.code_value != null &&
        this.selectVehicleClass.code_value != "" &&
        this.selectGroup != null &&
        this.selectGroup != ""
      ) {
        that.selectVehicleClass = value;
        that.btnCtrl = false;
        that.darkCtrl = true;
        that.delBtnCtrl = false;
        that.delDarkCtrl = true;
        that.selectValues = this.selectVehicleClass.code_value;
        that.selectValue = this.selectVehicleClass.code_text;
        that.vehicleClassName = that.selectValue;
        that.tableLoading(that.selectValues);
        that.VehicleCostInfoGet(that.selectValues);
        that.$refs.ryouEditTable.loadData();
        that.openEditTableForm();
        that.editems(that.selectValues);
      } else if (
        value != null &&
        value != "" &&
        this.selectGroup != null &&
        this.selectGroup != "" &&
        this.selectVehicleClass.code_value != ""
      ) {
        that.btnCtrl = false;
        that.darkCtrl = true;
        that.delBtnCtrl = true;
        that.delDarkCtrl = false;
        that.selectVehicleClass = { code_value: "", code_text: value };
        that.selectValue = this.selectVehicleClass.code_text;
        that.vehicleClassName = that.selectValue;
        that.openEditTableForm();
      } else {
        that.VehicleCostCard = false;
        that.VehicleClassCard = false;
        that.userDateUpdateFlg = false;
        that.selectValues = null;
        that.tableLoading(that.selectValues);
      }
    },
  },
  methods: {
    tableLoading(value) {
      if (this.selectGroup == "") {
        this.selectGroup = null;
      }
      this.$refs.ryouTable.url.list =
        this.url.originlist + this.selectGroup + "/" + value;
      this.$refs.ryouTable.loadData();
      this.$refs.ryouTable.selected = [];
    },
    editems(value) {
      this.$refs.ryouEditTable.editItems[0].build_group_id = this.selectGroup;
      this.$refs.ryouEditTable.editItems[0].vehicle_id = "";
      this.$refs.ryouEditTable.editItems[0].vehicle_class = value;
    },
    handleVehicleCostAdd() {
      //新規追加
      this.openVehicleForm();
      let params = {
        build_group_id: this.selectGroup,
        vehicle_class_name: this.selectValue,
      };
      this.getRequest(
        "/masterParking/vehicleCostCheckGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.VehicleCostCard = true;
          this.build_group_id = this.selectGroup;
        }
      });
      setTimeout(() => {}, 100);
    },
    VehicleCostOk() {
      //車両料金マスタ登録更新
      this.openEditTableForm();
      this.$refs.ryouEditTable.loadData();
      var valid = this.$refs.vehicleForm.validate();
      if (valid) {
        if (this.userDateUpdateFlg) {
          this.$refs.confirm
            .open("更新", "更新します。宜しいですか？", { color: "info" })
            .then((confirm) => {
              if (confirm) {
                let count =
                  Number(this.management_number) - Number(this.manageCounts);
                this.countAddRow(count);
                let params = {
                  loginUserId: this.$store.getters.getUserId,
                  build_group_id: this.selectGroup, //物件グループID
                  vehicle_class: this.selectValues, //車両区分
                  vehicle_unit_price: this.model.vehicle_unit_price.toString(), //車両利用単価
                };
                // 駐車場情報更新
                this.putRequest(
                  "/masterParking/vehicleCostUpdate",
                  params,
                  this.$store.getters.getUserToken
                ).then((resp) => {
                  if (resp.success) {
                    this.VehicleCostInfoGet(this.selectValues);
                  }
                });
              }
            });
        } else {
          let params = {
            loginUserId: this.$store.getters.getUserId,
            vehicle_class_name: this.selectValue,
          };
          this.getRequest(
            "/masterParking/vehicleCostCheckGet",
            params,
            this.$store.getters.getUserToken
          ).then((data) => {
            if (data.success) {
              this.$refs.confirm
                .open("登録", "登録します。宜しいですか？", { color: "info" })
                .then((confirm) => {
                  if (confirm) {
                    let params = {
                      loginUserId: this.$store.getters.getUserId,
                      build_group_id: this.selectGroup, //物件グループID
                      vehicle_class: this.selectValues, //車両区分
                      vehicle_unit_price:
                        this.model.vehicle_unit_price.toString(), //車両利用単価
                      vehicle_class_name: this.selectValue, //車両区分名
                    };
                    this.postRequest(
                      "/masterParking/vehicleCostInsert",
                      params,
                      this.$store.getters.getUserToken
                    ).then((resp) => {
                      if (resp.success) {
                        this.getvehicleCostData();
                        this.VehicleCostCard = true;
                        this.VehicleClassCard = true;
                        this.vehicleClassNameList();
                        this.userDateUpdateFlg = true;
                        this.delBtnCtrl = false;
                        this.delDarkCtrl = true;
                      }
                    });
                  }
                });
            }
          });
        }
      }
    },
    VehicleCostCancel() {
      //閉じる
      this.openVehicleForm();
      //修正途中のデータをキャンセルし、元のデータに戻す。
      let params = {
        build_group_id: this.selectGroup,
        vehicle_class: this.selectValues,
      };
      this.getRequest(
        "/masterParking/vehicleCostListGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          if (data.result.length != 0) {
            this.model.vehicle_unit_price =
              data.result[0].vehicle_unit_price.toString();
            this.build_group_id = data.result[0].build_group_id;
            this.VehicleClassCountGet(this.selectValues);
          }
        }
      });
    },
    VehicleCostDelete() {
      // 車両料金マスタデータ削除
      var that = this;
      let params = {
        loginUserId: this.$store.getters.getUserId,
        build_group_id: this.selectGroup,
        vehicle_class: this.selectValues,
      };
      this.getRequest(
        "/masterParking/vehicleInfoCheckGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.$refs.confirm
            .open("削除", "削除します。宜しいですか？", { color: "blue" })
            .then((confirm) => {
              if (confirm) {
                this.deleteRequest(
                  "/masterParking/vehicleCostDelete",
                  params,
                  this.$store.getters.getUserToken
                ).then((res) => {
                  if (res.success) {
                    that.VehicleCostCard = false;
                    that.VehicleClassCard = false;
                    that.vehicleClassNameList();
                    that.selectVehicleClass = {
                      code_value: "",
                      code_text: "",
                    };
                    that.btnCtrl = true;
                    that.darkCtrl = false;
                  }
                });
              }
            });
        }
      });
      setTimeout(() => {}, 100);
    },
    VehicleCostInfoGet(value) {
      // 車両料金マスタデータ取得
      // var that = this;
      let params = {
        build_group_id: this.selectGroup,
        vehicle_class: value,
      };
      this.getRequest(
        "/masterParking/vehicleCostListGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          if (data.result.length != 0) {
            //車両マスタカードパネル、車両明細カードパネルを表示し
            this.btnCtrl = true;
            this.darkCtrl = false;
            this.VehicleCostCard = true;
            this.VehicleClassCard = true;
            this.userDateUpdateFlg = true;
            this.model.vehicle_unit_price =
              data.result[0].vehicle_unit_price.toString();
            this.build_group_id = data.result[0].build_group_id;
            this.VehicleClassCountGet(this.selectValues);
          } else {
            //車両マスタカードパネル、車両明細カードパネルは表示しない
            this.btnCtrl = false;
            this.darkCtrl = true;
            this.VehicleCostCard = false;
            this.VehicleClassCard = false;
            this.userDateUpdateFlg = false;
          }
        }
      });
      setTimeout(() => {}, 100);
    },

    VehicleClassCountGet(value) {
      // 車両マスタ件数取得
      var that = this;
      let params = {
        build_group_id: this.selectGroup,
        vehicle_class: value,
      };
      this.getRequest(
        "/masterParking/vehicleClassCountGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.management_number = data.result.toString();
          that.manageCounts = this.management_number;
        }
      });
    },

    buildGroupList() {
      //物件グループ名
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/masterParking/buildGroupGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.objectGroupItems = data.result;
          if(this.$store.getters.getUserClass != '1'){
              //総務以外は初期値セット
              this.selectGroup = data.result[0].build_group_id //物件グループID
            }
        }
      });
      setTimeout(() => {}, 100);
    },
    vehicleClassNameList() {
      //車両区分名
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
        build_group_id: this.selectGroup,
      };
      this.getRequest(
        "/masterParking/vehicleClassNameGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.vehicleClassItems = data.result;
        }
      });
      setTimeout(() => {}, 100);
    },
    getvehicleCostData() {
      var that = this;
      let params = {
        build_group_id: this.selectGroup,
        vehicle_class_name: this.selectValue,
      };
      this.getRequest(
        "/masterParking/vehicleCostRecordGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          that.model.vehicle_unit_price =
            data.result[0].vehicle_unit_price.toString();
          that.build_group_id = data.result[0].build_group_id;
          that.selectValues = data.result[0].vehicle_class;
          that.tableLoading(that.selectValues);
          that.editems(that.selectValues);
          that.Counts = this.management_number;
          that.VehicleClassCountGet(that.selectValues);
          let count = Number(that.Counts) - Number(this.manageCounts);
          that.countAddRow(count);
        }
      });
    },
    countAddRow(count) {
      //管理台数行追加
      //不足している管理台数分を登録中駐車番号一覧グリッドに入力枠として表示する
      var that = this;
      for (let rows = 1; rows <= count - 1; rows++) {
        var lastRow = this.$refs.ryouEditTable.getLastRow();
        var newRow = { ...lastRow };
        newRow.build_group_id = that.selectGroup;
        newRow.vehicle_class = that.selectValues;
        this.$refs.ryouEditTable.addRow(newRow);
      }
    },
    doGridAddRow() {
      //行追加
      var that = this;
      var checkedRowArray = this.$refs.ryouTable.getCheckedRows();
      if (checkedRowArray && checkedRowArray.length == 0) {
        // 一覧のチェックボックスが未チェックの場合
        var lastRow = this.$refs.ryouEditTable.getLastRow();
        var newRow = { ...lastRow };
        newRow.build_group_id = that.selectGroup;
        newRow.vehicle_class = that.selectValues;
        //登録中駐車番号一覧グリッドの一番下に１行入力項行を追加する。
        this.$refs.ryouEditTable.addRow(newRow);
      } else {
        // 一覧グリッドにチェックがある場合
        //チェックしている行の車両IDの値をコピーして、登録中駐車番号一覧グリッドの一番下の行に１行追加する。
        this.$refs.ryouEditTable.addRows(checkedRowArray);
      }
    },
    doGridValidateSubmit() {
      //車両マスタ登録
      this.$refs.tableForm.tableForm = true;
      var valid = this.$refs.editTableForm.validate();
      if (valid) {
        this.$refs.confirm
          .open("登録", "登録します。宜しいですか？", { color: "info" })
          .then((confirm) => {
            if (confirm) {
              let allRows = this.$refs.ryouEditTable.getAllRow();
              this.postRequest(
                "/masterParking/vehicleClassInsert?loginUserId=" +
                  this.$store.getters.getUserId,
                allRows,
                this.$store.getters.getUserToken
              ).then((resp) => {
                if (resp.success) {
                  this.$refs.ryouTable.loadData();
                  this.$refs.ryouTable.selected = [];
                  // 車両料金マスタデータ取得
                  this.VehicleCostInfoGet(this.selectValues);
                  this.VehicleClassCountGet();
                }
              });
            }
          });
      }
    },
    openVehicleForm() {
      //車両マスタカードreset
      this.$refs.vehicleForm.reset();
      this.$refs.vehicleForm.resetValidation();
    },
    openEditTableForm() {
      //登録中駐車番号一覧reset
      if (this.$refs.editTableForm) {
        this.$refs.editTableForm.reset();
        this.$refs.editTableForm.resetValidation();
      }
    },
  },
};
</script>

<style scoped>
.mstDetail {
  padding: 30px 40px;
}

.titPadding {
  padding-bottom: 15px;
}

.mstgridlist {
  outline: 1px solid rgb(147, 179, 204);
  padding-left: 2%;
  padding-right: 2%;
  border-radius: 0%;
  margin-top: 10px;
}

.mstgridlist9 {
  outline: 1px solid rgb(147, 179, 204);
  height: 500px;
  padding-left: 2%;
  padding-right: 2%;
  border-radius: 0%;
  margin-top: 30px;
}

.mstAddbtn {
  padding-left: 20px;
  padding-top: 30px;
}

.mstYesbtn {
  text-align: right;
  padding-right: 20px;
  padding-top: 30px;
}

.mstheaderTitle {
  padding-bottom: 0px;
}

.mstheaderData {
  padding-top: 1.2%;
  padding-left: 1%;
}

.mstbuken {
  height: 60px;
  padding-top: 7%;
}
</style>
